<div class="layout-container">
  <!-- Toolbar -->
  <mat-toolbar color="primary" class="nav-toolbar">
    <img src="phoenix-logo-corp.svg" alt="Phoenix Logo" class="toolbar-logo" (click)="goToDashboard()">
    <span class="toolbar-title">Vertragsportal</span>
    <span class="spacer"></span>

    <mat-slide-toggle
      [checked]="themeService.isDarkMode()"
      (change)="toggleTheme()"
      color="accent"
      class="theme-toggle-toolbar">
      <mat-icon fontSet="material-symbols-outlined">{{ themeService.isDarkMode() ? 'light_mode' : 'dark_mode'}}</mat-icon>
    </mat-slide-toggle>

    <div class="selectedIdf">{{getCustomerName()}}<p>{{getIdf()}}</p></div>

    <button mat-button [matMenuTriggerFor]="menu" class="user-button">
      <mat-icon fontSet="material-symbols-outlined">account_circle</mat-icon>
      <span>{{ username() }}</span>
      <mat-icon fontSet="material-symbols-outlined">arrow_drop_down</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item>
        <mat-icon fontSet="material-symbols-outlined" >person</mat-icon>
        <span>Profil</span>
      </button>
      <button mat-menu-item>
        <mat-icon fontSet="material-symbols-outlined">settings</mat-icon>
        <span>Einstellungen</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logout()">
        <mat-icon fontSet="material-symbols-outlined">logout</mat-icon>
        <span>Abmelden</span>
      </button>
    </mat-menu>
  </mat-toolbar>

  <!-- Main Content -->
  <main class="main-content">
    <router-outlet></router-outlet>
  </main>

  <!-- Footer -->
  <footer class="app-footer">
    <div class="footer-content">
      <span>&copy; {{ currentYear }} Phoenix Portal. Alle Rechte vorbehalten.</span>
      <div class="footer-links">
        <a href="#" class="footer-link">Datenschutz</a>
        <span class="footer-separator">|</span>
        <a href="#" class="footer-link">Impressum</a>
        <span class="footer-separator">|</span>
        <a href="#" class="footer-link">Kontakt</a>
      </div>
    </div>
  </footer>
</div>
